'use strict';
import actionTypes from './actionTypes';
import toastr from 'toastr';

toastr.options.preventDuplicates = true;

let $;
if (typeof window !== 'undefined') {
    $ = window.$;
}

// Post Favorite Wishlist - Item
function setFavoriteWishlist(options, callback) {
    return function(dispatch) {
        $.ajax({
            url: '/wishlist',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(options), // Ensure data is a JSON string
            dataType: 'json', // Expect JSON response
            success: function(result) {
                if (typeof callback == 'function') {
                    callback(result);
                }

                return dispatch({ type: '' });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
                if (typeof callback == 'function') callback();
                return dispatch({ type: '' });
            }
        });
    };
}

// Delete Favorite Wishlist - Item
function delFavoriteWishlist(payload, callback) {
    return function(dispatch) {
        $.ajax({
            url: `/wishlist/user/${payload.userID}?wishlistId=` + payload.wishlistId,
            type: 'DELETE',
            success: function(result) {
                if (typeof callback == 'function') {
                    callback(result);
                }

                return dispatch({ type: '' });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
                if (typeof callback == 'function') callback();
                return dispatch({ type: '' });
            }
        });
    };
}

function goToPage(pageNumber, filters) {
    return function(dispatch, getState) {
        const state = getState().wishlistReducer;

        $.ajax({
            url: '/wishlist/search/items/ajax',
            type: 'GET',
            data: {
                pageSize: state.pageSize,
                pageNumber: pageNumber,
                sort: state.sort
            },
            success: function(items) {
                return dispatch({
                    type: actionTypes.GO_TO_PAGE,
                    items: items,
                    pageNumber: pageNumber
                });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function sortResult(sort) {
    return function(dispatch, getState) {
        const state = getState().wishlistReducer;

        $.ajax({
            url: '/wishlist/search/items/ajax',
            type: 'GET',
            data: {
                pageSize: state.pageSize,
                pageNumber: state.pageNumber,
                sort: sort
            },
            success: function(result) {
                return dispatch({
                    type: actionTypes.SORT_WISHLIST_RESULT,
                    items: result,
                    sort: sort
                });
            },

            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

export { setFavoriteWishlist, delFavoriteWishlist, goToPage, sortResult };

export default {
    setFavoriteWishlist: setFavoriteWishlist,
    delFavoriteWishlist: delFavoriteWishlist,
    goToPage: goToPage,
    sortResult: sortResult
};
